export default __webpack_public_path__ + "static/media/geofence.12afbc1e.jpg";